// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__Ikwpy","choiceBoxes":"toolbarselects_choiceBoxes__35_YW","simpleField":"toolbarselects_simpleField__18MO4"};